import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { TeamsVoicePolicies } from '../../../shared/models/generated/ziroModels';

@Injectable()
export class MicrosoftVoicePoliciesResource {
  private http = inject(HttpClient);

  get(tenantId: number, upn: string, isResourceAccount: boolean): Observable<TeamsVoicePolicies> {
    return this.http.get<TeamsVoicePolicies>(this._buildUrl(tenantId, upn, isResourceAccount));
  }

  put(tenantId: number, upn: string, body: TeamsVoicePolicies, isResourceAccount: boolean): Observable<void> {
    return this.http.put<void>(this._buildUrl(tenantId, upn, isResourceAccount), body);
  }

  delete(upn: string, isResourceAccount: boolean, tenantId: string): Observable<void> {
    const blankBody: TeamsVoicePolicies = {
      userPrincipalName: upn,
      callingLineIdentity: 'Global',
      callingPolicy: 'Global',
      emergencyCallRoutingPolicy: 'Global',
      emergencyCallingPolicy: 'Global',
      ipPhonePolicy: 'Global',
      onlineVoiceRoutingPolicy: 'Global',
      onlineVoicemailPolicy: 'Global',
      teamsCallHoldPolicy: 'Global',
      teamsCallParkPolicy: 'Global',
      tenantDialPlan: 'Global',
      sharedCallRoutingPolicy: {
        policyName: 'Global',
        resourceAccountUpn: '',
        resourceAccountDisplayName: '',
        resourceAccountLineUri: '',
      },
    };
    return this.http.put<void>(this._buildUrl(Number(tenantId), upn, isResourceAccount), blankBody);
  }

  private _buildUrl(tenantId: number, upn: string, isResourceAccount: boolean): string {
    return `/services/microsoft/macs/tenants/${tenantId}/teams-voice-policies/${encodeURIComponent(upn)}?isResourceAccount=${isResourceAccount}`;
  }
}
